import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/indexRedux';
import Loading from '../components/ui/Loading';

const AdminProtectedRoute: React.FC = () => {
  const { user, loading } = useSelector((state: RootState) => state.user);

  // Profile is fetched asynchronously on mount — wait for it before deciding
  if (loading || !user) {
    return <Loading />;
  }

  if (user.role !== 'admin') {
    return <Navigate to='/overview' replace />;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;
